
import SideBar from '../components/SideBar';
import DetailsPageHeader from '../components/DetailsPageHeader';
import { ReactComponent as DashboardIcon } from '../components/svgs/dashboardicon.svg';
import { ReactComponent as OrderIcon } from '../components/svgs/ordersicon.svg';
import { ReactComponent as CustomerIcon } from '../components/svgs/customersicon.svg';
import CustomerDetailsTab from '../components/CustomerDetailsTab';

const AttendantSidebarLinks = [
    { to: '/', icon: <DashboardIcon />, text: 'Dashboard', isActive: false },
    { to: '/orders', icon: <OrderIcon />, text: 'Orders', isActive: false },
    { to: '/customers', icon: <CustomerIcon />, text: 'Customers', isActive: true },
  
  ];

const CustomerDetailScreen = () => {


  return (
    <>
        <section className='dashboard-container flex '>
        <aside className=''>
        <SideBar links={AttendantSidebarLinks}/>
        </aside>
        <main className='main-container mb-32'>
            <DetailsPageHeader pageName={'customer'} customerDetails={'Phoebe Buffay'}/>
            <section className='mt-10 flex gap-5'>
                <div className=''>
                    <div className='laundry-details-title-items gap-10'>
                        {/* <div className='multi-file-icon-border'>
                            <MultiFileIcon className='ml-5 mt-5'/>
                        </div> */}
                        <div className='company-initials2 mt-4'>
                            <p className='company-initials-text company-initials-text2'>GI</p>
                        </div>
                        <div className='flex flex-col gap-2.5'>
                            <p className='order-name'>Phoebe Buffay</p>
                            <div className='flex gap-4 account-type-container'>
                                <p className='order-status account-type-text'>Personal Account</p>
                                
                            </div>
                            
                        </div>
                        <section className='order-details-more-options'>
                                <div className='order-status-option-dropdown'>
                                    
                                    <select className='mt-6'>
                                        <option value="option1">More options</option>
                                        <option value="option2">Washing</option>
                                        <option value="option3">Drying</option>
                                        <option value="option3">Folding</option>
                                        <option value="option3">Complete</option>
                                        {/* <option value="option3">Laundry Works</option> */}
                                    </select>
                                
                                </div>
                        </section>
                        
                    </div>
                    
                </div>
            
            </section>
            <section className='mt-10 flex gap-4'>
                <section>
                    <CustomerDetailsTab />

            </section>
           
          </section>
        </main>
      </section>
    </>
  )
}

export default CustomerDetailScreen